export const onClickStopPropagation = e => {
    e.stopPropagation();
};
